import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: 'textarea[muiTextareaAutoResize]',
  exportAs: 'muiTextarea'
})
export class MuiTextareaDirective {

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('muiTextareaAutoResize') autoResize = true;

  constructor(private _el: ElementRef, private _renderer2: Renderer2) {}

  @HostListener('input')
  private handleInputEvent(): void {
    if (this.autoResize) {
      this._renderer2.setStyle(this._el.nativeElement, 'height', '5px');
      const height = this._el.nativeElement.scrollHeight + 2; // add border top and bottom width
      this._renderer2.setStyle(this._el.nativeElement, 'height', height + 'px');
    }
  }
}
